import { LeadEventType } from "../shared/types";

export const PIPEDRIVE_ACTIONS = [
  "moveToStage",
  "addActivity",
  "addNote",
  "updateCustomFields",
  "setOwner",
  "setAsLost",
  "setAsOpen",
  "createDeal",
] as const;

export type PipedriveAction = (typeof PIPEDRIVE_ACTIONS)[number];

export const PIPEDRIVE_CONDITIONS = [
  "noInteraction",
  "interaction",
  "appointmentIntention",
] as const;

export type PipedriveCondition = (typeof PIPEDRIVE_CONDITIONS)[number];

export const getPipedriveConditionLabel = (condition: PipedriveCondition): string => {
  const labels: Record<PipedriveCondition, string> = {
    noInteraction: "Sin interacción",
    interaction: "Con interacción",
    appointmentIntention: "Intención de cita",
  };
  return labels[condition] || condition;
};

export type PipedriveActivity = {
  activityType: string;
  activityTypeAppointment?: string;
  activityTypeVirtualAppointment?: string;
  activitySubject: string;
  activityDueDateType?: "today" | "appointmentDate";
};

export type PipedriveEventMapping = {
  event: LeadEventType;
  condition?: {
    type: PipedriveCondition;
  };
  moveToStage?: {
    stageId: number;
    stageName?: string;
  };
  addActivities?: PipedriveActivity[];
  addNote?: {
    content: string;
  };
  updateCustomFields?: {
    customFields: Array<{
      fieldId: string;
      value: string;
    }>;
  };
  setOwner?: boolean;
  setAsLost?: {
    lostReason: string;
  };
  setAsOpen?: boolean;
  createDeal?: {
    dealTitle: string;
    stageId: number;
    stageName?: string;
  };
};

export const getPipedriveActionLabel = (action: PipedriveAction): string => {
  const labels: Record<PipedriveAction, string> = {
    moveToStage: "Mover a Etapa",
    addActivity: "Agregar Actividad",
    addNote: "Agregar Nota",
    updateCustomFields: "Actualizar Campos Personalizados",
    setOwner: "Asignar Propietario",
    setAsLost: "Marcar como Perdido",
    setAsOpen: "Marcar como Abierto",
    createDeal: "Crear Deal",
  };
  return labels[action] || action;
};

export const getAvailableActionsForEvent = (event: LeadEventType): PipedriveAction[] => {
  if (event === "lead.created") {
    return PIPEDRIVE_ACTIONS.filter((a) => a !== "setAsOpen") as unknown as PipedriveAction[];
  }
  return PIPEDRIVE_ACTIONS.filter((a) => a !== "createDeal") as unknown as PipedriveAction[];
};
